module.exports = __webpack_public_path__ + "img/cmb_temp_potrait.e2a9bae7.png";